'use strict';

export default {
    collapsed: state => state.collapsed
};
